export default "__VITE_ASSET__106b8089__"